import { render, staticRenderFns } from "./BusquedaDetallada.vue?vue&type=template&id=3c3e4224&scoped=true"
import script from "./BusquedaDetallada.vue?vue&type=script&lang=js"
export * from "./BusquedaDetallada.vue?vue&type=script&lang=js"
import style0 from "./BusquedaDetallada.vue?vue&type=style&index=0&id=3c3e4224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3e4224",
  null
  
)

export default component.exports